module.exports = __webpack_public_path__ + "img/sketch.e7c82e5c.jpg";